import { FormDataOptionsType } from 'Helpers'
import { isEmpty } from 'lodash'
import moment from 'moment/moment'

export const isEmptyValue = (value: any): boolean =>
	value === null ||
	typeof value === 'undefined' ||
	value === '' ||
	(typeof value === 'number' && Number.isNaN(value)) ||
	(Array.isArray(value) && !value.length) ||
	(typeof value === 'object' && isEmpty(value))

export const toFormData = (object, options?: FormDataOptionsType): any => {
	const data = new FormData()
	const keys = Object.keys(object)
	keys.forEach((key: string): void => {
		if (object[key] !== undefined) data.append(`[data][${key}]`, object[key])
	})
	if (Boolean(options?.prepareFiles) && object?.[options.prepareFiles]?.length) {
		data.delete(`[data][${options.prepareFiles}]`)
		object[options.prepareFiles].forEach((file, index): void =>
			data.append(
				`[data][${options.prepareFiles}][${index}][file]`,
				object[options.prepareFiles][index]
			)
		)
	}
	if (options?.toArray?.length) {
		options.toArray.forEach((field): void => {
			if (object?.[field]?.length) {
				data.delete(`[data][${field}]`)
				object[field].forEach((item): void => {
					Object.keys(item)?.forEach((key): void => {
						data.append(`[data][${field}][][${key}]`, item[key])
					})
				})
			}
		})
	}
	if (Boolean(options?.renameFiles) && object) {
		Object.keys(options.renameFiles).forEach((key): void => {
			if (object[key]) {
				data.delete(`[data][${key}]`)
				data.append(`[data][${key}]`, object[key], options.renameFiles[key])
			}
		})
	}

	return data
}

export const undefinedToNull = (obj: any) => {
	const keys = Object.keys(obj)
	keys.forEach((key: string): void => {
		if (obj[key] === undefined) obj[key] = null
	})

	return obj
}

export const getDate = (date): string => {
	if (!date) return ''
	const fullDate = new Date(date)
	const month =
		fullDate.getMonth() + 1 < 10 ? `0${fullDate.getMonth() + 1}` : fullDate.getMonth() + 1
	const day = fullDate.getDate() < 10 ? `0${fullDate.getDate()}` : fullDate.getDate()
	return `${day}.${month}.${fullDate.getFullYear()}`
}

export const getTime = (date, showSecond = false): string => {
	if (!date) return ''
	const fullDate = new Date(date)
	const minutes = fullDate.getMinutes() < 10 ? `0${fullDate.getMinutes()}` : fullDate.getMinutes()
	const seconds = fullDate.getSeconds() < 10 ? `0${fullDate.getSeconds()}` : fullDate.getSeconds()
	return showSecond
		? `${fullDate.getHours()}:${minutes}:${seconds}`
		: `${fullDate.getHours()}:${minutes}`
}

export const leftHours = (minend: string): { hours: number; minutes: number } => {
	const m: number = new Date(minend).getTime() - Date.now()

	const hours = Math.floor(m / 1000 / 60 / 60)
	const minutes = Math.floor(m / 1000 / 60 - hours * 60)
	return {
		hours,
		minutes,
	}
}

export const validateDate = (value: string, format?: string) => {
	if (format) return moment(value, format, true).isValid()
	return moment(value).isValid()
}
